import { SanityGridBackground } from '@data/sanity/queries/types/modules'

type ColorClassMap = Record<SanityGridBackground, string | string[]>

export const gridColorClasses: ColorClassMap = {
  gradient: 'bg-gradient-to-br from-gradient-from to-gradient-to text-white',
  'light-gray': 'bg-gray-light text-black',
  gray: 'bg-gray text-black',
  'dark-gray': 'bg-gray-dark text-white',
  red: 'bg-red text-white',
  'dark-red': 'bg-red-dark text-white',
  blue: 'bg-blue text-white',
  'dark-blue': 'bg-blue-dark text-white',
}
